import { db, type Snapshot } from '../codexDB';
import { newId } from '@/lib/id';
import { buildExportBundle, importBundle, parseBundle } from './exportBundle';

/** 파괴적 동작(삭제·초기화·대치 가져오기) 전 자동 백업 (02 §6 / 08 §0.6) */
export async function createSnapshot(reason: string): Promise<string> {
  const bundle = await buildExportBundle();
  const id = newId('snap');
  await db.snapshots.add({ id, ts: Date.now(), reason, bundle });
  return id;
}

export async function listSnapshots(): Promise<Snapshot[]> {
  return db.snapshots.orderBy('ts').reverse().toArray();
}

export async function restoreSnapshot(id: string): Promise<void> {
  const snap = await db.snapshots.get(id);
  if (!snap) throw new Error('스냅샷을 찾을 수 없습니다');
  const { bundle, assetsIncluded } = parseBundle(snap.bundle);
  await importBundle(bundle, 'replace', { assetsIncluded });
}

export async function deleteSnapshot(id: string): Promise<void> {
  await db.snapshots.delete(id);
}
